import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { lenderRankingTableDisplay } from '../../../model/LenderRankingTable';
import { LenderRankingInsuranceTable } from '../../../model/LenderRankingInsuranceTable';
import { InsuranceAcquisitionDetails } from '../../../model/InsuranceAcquisitionDetails';
import * as _ from 'lodash-es';
import { AcqnFilterService } from 'src/app/services/acqn-filter-service';
import { AcqnFiltersDetails } from '../../model/AcqnFiltersDetails';
import { StatsDataService } from 'src/app/services/stats-data.service';
import { FilterDetailsSourceType } from 'src/app/shared/enum-value';
import { InsuranceService } from 'src/app/services/insurance.service';


@Component({
  standalone: false,
  selector: 'app-lender-ranking-insurance',
  templateUrl: './lender-ranking-insurance.component.html',
  styleUrls: ['./lender-ranking-insurance.component.css']
})
export class LenderRankingInsuranceComponent implements OnInit {

  // https://angular.io/guide/component-interaction
  @Input() set acqnDetails(acqnDetails: InsuranceAcquisitionDetails) {
    this.lenderRankingTabDetails = acqnDetails;
    this.loadTable();
  }

  @Input() selectStartPeriod: any[] = [];
  @Input() selectedStartPeriod: string = "";
  @Input() selectEndPeriod: any[] = [];
  @Input() selectedEndPeriod: string = "";
  @Output() refreshAcqnDetails: EventEmitter<object> = new EventEmitter<object>();
  @Output() getEndPeriodDates: EventEmitter<object> = new EventEmitter<object>();
  @Output() openAcqnFilterSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();

  //lender ranking variables
  lenderRankingTableColumns: any[];
  lenderRankingTableDisplay: lenderRankingTableDisplay[] = [];
  lenderRankingTable: LenderRankingInsuranceTable[] = [];
  lenderRankingTabDetails: InsuranceAcquisitionDetails;
  ySumINSR: number = 0;
  nSumINSR: number = 0;
  naSumINSR: number = 0;
  //insr docs
  ySumA25: number = 0;
  nSumA25: number = 0;
  naSumA25: number = 0;
  ySumA28: number = 0;
  nSumA28: number = 0;
  naSumA28: number = 0;
  ySumALTA: number = 0;
  nSumALTA: number = 0;
  naSumALTA: number = 0;
  ySumFAW: number = 0;
  nSumFAW: number = 0;
  naSumFAW: number = 0;
  ySumLIA: number = 0;
  nSumLIA: number = 0;
  naSumLIA: number = 0;
  ySumNFIP: number = 0;
  nSumNFIP: number = 0;
  naSumNFIP: number = 0;
  ySumPFX: number = 0;
  nSumPFX: number = 0;
  naSumPFX: number = 0;
  ySumPROP: number = 0;
  nSumPROP: number = 0;
  naSumPROP: number = 0;
  ySumSFHDF: number = 0;
  nSumSFHDF: number = 0;
  naSumSFHDF: number = 0;
  ySumSOV: number = 0;
  nSumSOV: number = 0;
  naSumSOV: number = 0;

  compliant: number = 0;
  nonCompliant: number = 0;
  acquisitionsCount: number = 0;
  complianceRateLenderRanking: number = 0;
  submissionRateLenderRanking: number = 0;
  totalY: number = 0;
  totalYN: number = 0;


  constructor(private acqnFiltersService: AcqnFilterService,
    private statsDataService: StatsDataService,
    private insuranceService: InsuranceService) { }

  ngOnInit(): void {
    this.acqnFiltersService.acqnFiltersDetailsSub.subscribe((acqnFiltersDetails: AcqnFiltersDetails) => {
      if (acqnFiltersDetails.source.includes(FilterDetailsSourceType.AcqnFilter)) {
        this.selectedStartPeriod = acqnFiltersDetails.startPeriod;
        this.selectedEndPeriod = acqnFiltersDetails.endPeriod;
        this.onGetEndPeriodDates();
      }
    });


    //Lender Ranking Tab variables
    this.lenderRankingTableColumns = [
      { field: "lenderName", header: "Lender Name", width: "50%" },
      { field: "complianceRate", header: "Compliance Rate", width: "25%" },
      { field: "submissionRate", header: "Submission Rate", width: "25%" }
    ];

  }

  //lender ranking methods
  public resetValues() {
    this.ySumINSR = 0;
    this.nSumINSR = 0;
    this.naSumINSR = 0;
    this.ySumA25 = 0;
    this.nSumA25 = 0;
    this.naSumA25 = 0;
    this.ySumA28 = 0;
    this.nSumA28 = 0;
    this.naSumA28 = 0;
    this.ySumALTA = 0;
    this.nSumALTA = 0;
    this.naSumALTA = 0;
    this.ySumFAW = 0;
    this.nSumFAW = 0;
    this.naSumFAW = 0;
    this.ySumLIA = 0;
    this.nSumLIA = 0;
    this.naSumLIA = 0;
    this.ySumNFIP = 0;
    this.nSumNFIP = 0;
    this.naSumNFIP = 0;
    this.ySumPFX = 0;
    this.nSumPFX = 0;
    this.naSumPFX = 0;
    this.ySumPROP = 0;
    this.nSumPROP = 0;
    this.naSumPROP = 0;
    this.ySumSFHDF = 0;
    this.nSumSFHDF = 0;
    this.naSumSFHDF = 0;
    this.ySumSOV = 0;
    this.nSumSOV = 0;
    this.naSumSOV = 0;
    
    this.compliant = 0;
    this.nonCompliant = 0;
    this.acquisitionsCount = 0;
    this.complianceRateLenderRanking = 0;
    this.submissionRateLenderRanking = 0;
    this.totalY = 0;
    this.totalYN = 0;
    this.lenderRankingTable = [];
  }

  public loadTable() {
   // console.log('Lender Ranking Table Display:', this.lenderRankingTabDetails.acqInsuranceDetails);
    this.resetValues();
    if (this.lenderRankingTabDetails.acqInsuranceDetails) {
     // this.acquisitionsCount = _.filter(this.lenderRankingTabDetails.acqInsuranceDetails, function (o) { return o.acquisitionStatus == 'Acquired' }).length;

     //todo - remove pending  as we calculating only for acquired 

      for (let i = 0; i < this.lenderRankingTabDetails.acqInsuranceDetails.length; i++) {
        if (this.lenderRankingTabDetails.acqInsuranceDetails[i].acquisitionStatus == 'Acquired' ) {
          let tempIndex = _.findIndex(this.lenderRankingTable, ['lenderName', this.lenderRankingTabDetails.acqInsuranceDetails[i].lender]);
          if (tempIndex != -1) {
            this.getReportCounts(i, tempIndex);
          } else {
            tempIndex = this.lenderRankingTable.length;
            this.lenderRankingTable.push({
              lenderName: this.lenderRankingTabDetails.acqInsuranceDetails[i].lender,
              complianceRate: 0,
              submissionRate: 0,
              y: 0,
              yn: 0,
              yINSR: 0,
              nINSR: 0,
              naINSR: 0,
              yA25: 0,
              nA25: 0,
              naA25: 0,
              yA28: 0,
              nA28: 0,
              naA28: 0,
              yALTA: 0,
              nALTA: 0,
              naALTA: 0,
              yFAW: 0,
              nFAW: 0,
              naFAW: 0,
              yLIA: 0,
              nLIA: 0,
              naLIA: 0,
              yNFIP: 0,
              nNFIP: 0,
              naNFIP: 0,
              yPFX: 0,
              nPFX: 0,
              naPFX: 0,
              yPROP: 0,
              nPROP: 0,
              naPROP: 0,
              ySFHDF: 0,
              nSFHDF: 0,
              naSFHDF: 0,
              ySOV: 0,
              nSOV: 0,
              naSOV: 0,
              compliant: 0,
              nonCompliant: 0
            });
            this.getReportCounts(i, tempIndex);
          }
          //compliance rate
            this.lenderRankingTable[tempIndex].complianceRate = (
              this.lenderRankingTable[tempIndex].compliant /
              (this.lenderRankingTable[tempIndex].compliant + this.lenderRankingTable[tempIndex].nonCompliant)
            );

          //submission rate

           this.lenderRankingTable[tempIndex].y = this.lenderRankingTable[tempIndex].yINSR +this.lenderRankingTable[tempIndex].yA25 + 
           this.lenderRankingTable[tempIndex].yA28 + this.lenderRankingTable[tempIndex].yALTA + this.lenderRankingTable[tempIndex].yFAW + 
           this.lenderRankingTable[tempIndex].yLIA + this.lenderRankingTable[tempIndex].yNFIP + this.lenderRankingTable[tempIndex].yPFX + 
           this.lenderRankingTable[tempIndex].yPROP + this.lenderRankingTable[tempIndex].ySFHDF + this.lenderRankingTable[tempIndex].ySOV;
           
           this.lenderRankingTable[tempIndex].yn = this.lenderRankingTable[tempIndex].y + this.lenderRankingTable[tempIndex].nINSR
            + this.lenderRankingTable[tempIndex].nA25 + this.lenderRankingTable[tempIndex].nA28 
            + this.lenderRankingTable[tempIndex].nALTA +this.lenderRankingTable[tempIndex].nFAW  
            + this.lenderRankingTable[tempIndex].nLIA + this.lenderRankingTable[tempIndex].nNFIP 
            + this.lenderRankingTable[tempIndex].nPFX + this.lenderRankingTable[tempIndex].nPROP 
            + this.lenderRankingTable[tempIndex].nSFHDF + this.lenderRankingTable[tempIndex].nSOV;

          if (this.lenderRankingTable[tempIndex].yn === 0) {
            this.lenderRankingTable[tempIndex].submissionRate = 1; // Default value when denominator is 0, (when all are N/A)
          } else {
            this.lenderRankingTable[tempIndex].submissionRate = (
              this.lenderRankingTable[tempIndex].y / this.lenderRankingTable[tempIndex].yn
            );
          }
      }


      }

    } else {
      this.lenderRankingTable = [];
    }


    for (let i = 0; i < this.lenderRankingTable.length; i++) {
      this.ySumINSR = this.ySumINSR + this.lenderRankingTable[i].yINSR;
      this.nSumINSR = this.nSumINSR + this.lenderRankingTable[i].nINSR;
      this.naSumINSR = this.naSumINSR + this.lenderRankingTable[i].naINSR;
      this.ySumA25 = this.ySumA25 + this.lenderRankingTable[i].yA25;
      this.nSumA25 = this.nSumA25 + this.lenderRankingTable[i].nA25;
      this.naSumA25 = this.naSumA25 + this.lenderRankingTable[i].naA25;
      this.ySumA28 = this.ySumA28 + this.lenderRankingTable[i].yA28;
      this.nSumA28 = this.nSumA28 + this.lenderRankingTable[i].nA28;
      this.naSumA28 = this.naSumA28 + this.lenderRankingTable[i].naA28;
      this.ySumALTA = this.ySumALTA + this.lenderRankingTable[i].yALTA;
      this.nSumALTA = this.nSumALTA + this.lenderRankingTable[i].nALTA;
      this.naSumALTA = this.naSumALTA + this.lenderRankingTable[i].naALTA;
      this.ySumFAW = this.ySumFAW + this.lenderRankingTable[i].yFAW;
      this.nSumFAW = this.nSumFAW + this.lenderRankingTable[i].nFAW;
      this.naSumFAW = this.naSumFAW + this.lenderRankingTable[i].naFAW;
      this.ySumLIA = this.ySumLIA + this.lenderRankingTable[i].yLIA;
      this.nSumLIA = this.nSumLIA + this.lenderRankingTable[i].nLIA;
      this.naSumLIA = this.naSumLIA + this.lenderRankingTable[i].naLIA;
      this.ySumNFIP = this.ySumNFIP + this.lenderRankingTable[i].yNFIP;
      this.nSumNFIP = this.nSumNFIP + this.lenderRankingTable[i].nNFIP;
      this.naSumNFIP = this.naSumNFIP + this.lenderRankingTable[i].naNFIP;
      this.ySumPFX = this.ySumPFX + this.lenderRankingTable[i].yPFX;
      this.nSumPFX = this.nSumPFX + this.lenderRankingTable[i].nPFX;
      this.naSumPFX = this.naSumPFX + this.lenderRankingTable[i].naPFX;
      this.ySumPROP = this.ySumPROP + this.lenderRankingTable[i].yPROP;
      this.nSumPROP = this.nSumPROP + this.lenderRankingTable[i].nPROP;
      this.naSumPROP = this.naSumPROP + this.lenderRankingTable[i].naPROP;
      this.ySumSFHDF = this.ySumSFHDF + this.lenderRankingTable[i].ySFHDF;
      this.nSumSFHDF = this.nSumSFHDF + this.lenderRankingTable[i].nSFHDF;
      this.naSumSFHDF = this.naSumSFHDF + this.lenderRankingTable[i].naSFHDF;
      this.ySumSOV = this.ySumSOV + this.lenderRankingTable[i].ySOV;
      this.nSumSOV = this.nSumSOV + this.lenderRankingTable[i].nSOV;
      this.naSumSOV = this.naSumSOV + this.lenderRankingTable[i].naSOV;
      
      this.compliant = this.compliant + this.lenderRankingTable[i].compliant;
      this.nonCompliant = this.nonCompliant + this.lenderRankingTable[i].nonCompliant;
    }

    //get Y
    this.totalY = this.ySumINSR + this.ySumA25 + this.ySumA28 + this.ySumALTA + this.ySumFAW + this.ySumLIA + this.ySumNFIP + this.ySumPFX + this.ySumPROP + this.ySumSFHDF + this.ySumSOV;

    //get Y+N 
    //todo review
    this.totalYN = this.lenderRankingTable.reduce((sum, lender) => 
      sum + lender.yINSR + lender.nINSR + lender.yA25 + lender.nA25 + lender.yA28 + lender.nA28 + 
      lender.yALTA + lender.nALTA + lender.yFAW + lender.nFAW + lender.yLIA + lender.nLIA + 
      lender.yNFIP + lender.nNFIP + lender.yPFX + lender.nPFX + lender.yPROP + lender.nPROP + 
      lender.ySFHDF + lender.nSFHDF + lender.ySOV + lender.nSOV, 0);

    //get Compliance Rate
    if ((this.compliant + this.nonCompliant) != 0)
      this.complianceRateLenderRanking = (this.compliant / (this.compliant + this.nonCompliant));
    else
      this.complianceRateLenderRanking = 0;

    //get Submission Rate
    if (this.totalYN != 0)
      this.submissionRateLenderRanking = (this.totalY / this.totalYN);
    else
      this.submissionRateLenderRanking = 0;

    this.updateStatsData(this.lenderRankingTabDetails.acqInsuranceDetails);

    //default sort lender ranking table
    this.lenderRankingTableDisplay = _.orderBy(this.lenderRankingTable, ['complianceRate'], ['desc']);
  }

  private updateStatsData(acqInsuranceDetails) {
    let lenderStats = this.insuranceService.complianceCalculationInsurance(acqInsuranceDetails, "Y");
    this.statsDataService.setStatsDataDetails(lenderStats);
    this.statsDataService.notifySubscribers();
  }

  public getReportCounts(i, tempIndex) {
    //INSR
    if (this.lenderRankingTabDetails.acqInsuranceDetails[i].insr == 'Y') {
      this.lenderRankingTable[tempIndex].yINSR++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].insr == 'N') {
      this.lenderRankingTable[tempIndex].nINSR++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].insr == 'N/A') {
      this.lenderRankingTable[tempIndex].naINSR++;
    }

    //A25
    if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propAccord25Typ == 'Y') {
      this.lenderRankingTable[tempIndex].yA25++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propAccord25Typ == 'N') {
      this.lenderRankingTable[tempIndex].nA25++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propAccord25Typ == 'N/A') {
      this.lenderRankingTable[tempIndex].naA25++;
    }
    //A28
    if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propAccord28Typ == 'Y') {
      this.lenderRankingTable[tempIndex].yA28++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propAccord28Typ == 'N') {
      this.lenderRankingTable[tempIndex].nA28++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propAccord28Typ == 'N/A') {
      this.lenderRankingTable[tempIndex].naA28++;
    }
    //ALTA
    if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propAmrcnLandTtlAsscTyp == 'Y') {
      this.lenderRankingTable[tempIndex].yALTA++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propAmrcnLandTtlAsscTyp == 'N') {
      this.lenderRankingTable[tempIndex].nALTA++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propAmrcnLandTtlAsscTyp == 'N/A') {
      this.lenderRankingTable[tempIndex].naALTA++;
    }
    //FAW
    if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propFldAnlysWkshTyp == 'Y') {
      this.lenderRankingTable[tempIndex].yFAW++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propFldAnlysWkshTyp == 'N') {
      this.lenderRankingTable[tempIndex].nFAW++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propFldAnlysWkshTyp == 'N/A') {
      this.lenderRankingTable[tempIndex].naFAW++;
    }
    //LIA
    if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propLiabPlcyTyp == 'Y') {
      this.lenderRankingTable[tempIndex].yLIA++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propLiabPlcyTyp == 'N') {
      this.lenderRankingTable[tempIndex].nLIA++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propLiabPlcyTyp == 'N/A') {
      this.lenderRankingTable[tempIndex].naLIA++;
    }
//NFIP
    if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propNfipTyp == 'Y') {
      this.lenderRankingTable[tempIndex].yNFIP++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propNfipTyp == 'N') {
      this.lenderRankingTable[tempIndex].nNFIP++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propNfipTyp == 'N/A') {
      this.lenderRankingTable[tempIndex].naNFIP++;
    }

//PFX
    if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propPrvtOrExcsFldInsrCvrgTyp == 'Y') {
      this.lenderRankingTable[tempIndex].yPFX++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propPrvtOrExcsFldInsrCvrgTyp == 'N') {
      this.lenderRankingTable[tempIndex].nPFX++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propPrvtOrExcsFldInsrCvrgTyp == 'N/A') {
      this.lenderRankingTable[tempIndex].naPFX++;
    }
//PROP
    if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propInsrTyp == 'Y') {
      this.lenderRankingTable[tempIndex].yPROP++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propInsrTyp == 'N') {
      this.lenderRankingTable[tempIndex].nPROP++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propInsrTyp == 'N/A') {
      this.lenderRankingTable[tempIndex].naPROP++;
    }
//SFHDF
    if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propSpclFldHzrdDtmnFormTyp == 'Y') {
      this.lenderRankingTable[tempIndex].ySFHDF++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propSpclFldHzrdDtmnFormTyp == 'N') {
      this.lenderRankingTable[tempIndex].nSFHDF++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propSpclFldHzrdDtmnFormTyp == 'N/A') {
      this.lenderRankingTable[tempIndex].naSFHDF++;
    }

    //SOV
    if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propSchOfValTyp == 'Y') {
      this.lenderRankingTable[tempIndex].ySOV++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propSchOfValTyp == 'N') {
      this.lenderRankingTable[tempIndex].nSOV++;
    } else if (this.lenderRankingTabDetails.acqInsuranceDetails[i].propSchOfValTyp == 'N/A') {
      this.lenderRankingTable[tempIndex].naSOV++;
    }
    
  const complianceRate = this.lenderRankingTabDetails.acqInsuranceDetails[i].complianceRate;

      if (complianceRate) {
        switch (complianceRate.toLowerCase()) {
          case "compliant":
            this.lenderRankingTable[tempIndex].compliant++;
            break;
          case "non-compliant":
            this.lenderRankingTable[tempIndex].nonCompliant++;
            break;
          default:
            break;
        }
      } else {
      }
    }


  // Do a callback and refresh the acqnDetails
  public onRefreshAcqnDetails() {
    // Get start and end date and do a callback to get a new list
    let startDate = this.selectedStartPeriod;
    let endDate = this.selectedEndPeriod;
    let isLenderRanking: boolean = true;

    this.refreshAcqnDetails.emit({ startDate, endDate, isLenderRanking });
  }

  onGetEndPeriodDates() {
    // Get start and end date and do a callback to get a new list
    let startDate: string = this.selectedStartPeriod;
    let endDate: string = this.selectedEndPeriod;
    let isLenderRanking: boolean = true;
    let onload: boolean = false;

    this.getEndPeriodDates.emit({ startDate, endDate, isLenderRanking, onload });
  }

  showAcqnFilterSidebar() {
    this.acqnFiltersService.setSource(FilterDetailsSourceType.INSLenderRanking);
    this.acqnFiltersService.setStartPeriod(this.selectedStartPeriod);
    this.acqnFiltersService.setEndPeriod(this.selectedEndPeriod);

    this.acqnFiltersService.notifySubscribers();

    this.openAcqnFilterSidebar.emit(true);
  }
}
